import styled from "styled-components";
import { colors } from "../../consts";
import { Heading5, Paragraph2, TextButton, WrapperContainer } from "../../components";
import { ModalContainer } from "../../components/Modal/styled";
import { LinkStyled } from "../../components/NavLink/styled";

export const NavBarWrapper = styled(WrapperContainer)`
  background: ${colors.RAISIN_100};

  ${TextButton} {
    color: ${colors.ISABELLINE};
  }
`;

export const NavLinksWrapper = styled(WrapperContainer)`
  ${LinkStyled} {
    letter-spacing: 0.3px;

    &:hover {
      background: rgba(246, 244, 240, 0.1);
    }
  }
`;

export const ContentContainer = styled(ModalContainer)`
  padding: 24px 24px 29px;
  overflow: visible;

  ${Heading5} {
    margin-bottom: 34px;
  }

  input {
    width: 329px;
  }
`;

export const ButtonContainer = styled(WrapperContainer)`
  button {
    margin-top: 16px;
    max-width: 156px;
    max-height: 48px;
  }
`;

export const VersionTitle = styled(Paragraph2)`
  font-size: 8px;
  line-height: 14px;
  color: ${colors.RAISIN_50};
  font-weight: 500;
  margin-top: -18px;
`;
